export const URL = 'https://qa-be.app.journeysapac.lifesight.io';
